<template>
  <div class="form-v1">
    <template v-for="(item,i) in list">
      <v-layout :key="`a${i}`" class="a1a">
        <v-flex md4>Otros gastos</v-flex>
        <v-flex md5>Descripción</v-flex>
      <v-flex :md2="!view_only" :md3="view_only">Resultado (en MUSD BHP Share)</v-flex>
      <v-flex md1 v-if="!view_only"></v-flex>
      </v-layout>
      <v-layout :key="`b${i}`" class="a1b">
        <in-text v-model="item.other_expenses" md="4" :view_only="view_only"/>
        <in-text-area v-model="item.description" md="5" :view_only="view_only"/>
        <in-num v-model="item.financial_loss" :view_only="view_only" :md="view_only?3:2" class="text_align_right"/>
        <v-flex md1 v-if="!view_only"><v-btn small  @click="select_to_remove(item)" color="primary"><v-icon small>delete</v-icon></v-btn></v-flex>
      </v-layout>
    </template>
    <div class="p-flex" style="text-align: center;" v-if="!view_only">
      <v-btn @click="add" color="primary">
        <v-icon>add</v-icon>
        <span>Agregar otros gastos</span>
      </v-btn>
    </div>
    <v-dialog v-model="dialog" :persistent="true" :max-width="550" :class="'textAlignCenter'">
      <v-card class="pa-20 fs1_dialog" :class="'textAlignCenter'">
        <h2>{{'Eliminar Composición de Pérdida Estática'}}</h2>
        <br>	
        <div class="btns-container">
          <v-btn color="primary" @click="remove(selected_item)">Aceptar</v-btn>        
          <v-btn color="secondary" @click="dialog=false">Cancelar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import crud_t2 from '../../mixins/crud_t2';
export default {
  mixins:[crud_t2],
  props: [],
  components:{ },
  data() {
    return {
      scheme:{
        other_expenses: {type: 'string'},
        description: {type: 'string'},
        financial_loss: {type: 'int',default:0},
      }
    };
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  methods: {
  
  }, // methods
};
</script>
